<template>
    <div>
      <b-card >
        <b-row><b-col><h3>{{ this.myData[0] }} Commission Review</h3></b-col></b-row>
        <b-row><b-col><h3>{{this.ID}}</h3></b-col></b-row>
          <b-row><b-col><b>Commission Date:</b> {{ this.myData[1].CommissionDate }} </b-col>
          <b-col><b>Commission Time:</b> {{ this.myData[1].CommissionTime }} </b-col></b-row>
          <b-row><b-col><b>Dept:</b> {{ this.myData[1].DeptFloor }} </b-col>
          <b-col><b>Note:</b> {{ this.myData[1].LocationNote }}</b-col></b-row>
          <br/>
          <b-card-group deck>
            <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx" 
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col>{{ id.ProbeFeed }}</b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col>{{ id.ProbePosition }}</b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col><b-col>{{ id.ProbeRecirc}}</b-col></b-row>
        <b-row><b-col><b>Probe Tag</b></b-col><b-col><b-col>{{id.ProbeTag }}</b-col></b-col></b-row>
        <br/>
        <b-row><b-col><b>Calibration Temp</b></b-col><b-col>{{id.ProbeTemp}}&#8451;</b-col></b-row>
        <b-row><b-col><b>Calibration Flow</b></b-col><b-col>{{id.ProbeFlow}}</b-col></b-row>
        </b-card>     
        </b-card-group>
        </b-card>
        <b-card>
           <h3>Terms and Conditions <BIconXSquare v-if="this.TermsAccepted == 'FALSE'" variant="danger"/><BIconCheckSquare v-if="this.TermsAccepted == 'TRUE'" variant="success"/></h3>
        <p class="small">
          The purpose of the Clarence device is to provide periodic data to the
          user.</p>
          <p class="small">
          The device will provide an overview of the data collected to allow the user to monitor their compliance and risk via the analysis of key environmental parameters.
          </p>
          <p class="small">
          By clicking agree you hereby confirm that you accept the License
          Agreement and additionally grant
          permission to Angel Guard Limited to process the data from the device
          detailed above, in order to allow the device to function effectively.
        </p>

        <br />
        <b-row align="center" v-if="this.TermsAccepted == ''">
          <b-col><b-button variant="outline-success" size="sm" v-on:click="acceptTerms()">
            Accept
          </b-button></b-col>
          <b-col>          <b-button variant="outline-danger" size="sm" v-on:click="declineTerms()">
            Decline
          </b-button></b-col>
          </b-row>


        </b-card>
        <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false && this.TermsAccepted != ''" v-on:click="CompletePage()">Complete Commission</b-button></b-col></b-row>
    </div>
</template>

<script>
   import { BIconXSquare,BIconCheckSquare } from 'bootstrap-vue'
    export default {
      props:['DataPass','Type','ID','Feeds','Positions'],
      data() {
      return {
        stepComplete: false,
        Values: [],
        myData: [],
        ProbeArray: [],
        TermsAccepted: ""
      }
    },
    computed: {},
    components: {
      BIconXSquare,
      BIconCheckSquare
    },
    methods:{
      CompletePage(){
        this.Values = this.myData
        this.Values.push(this.TermsAccepted)
        this.$emit("PageComplete",5,this.Values);
        this.stepComplete = true;
      },
      acceptTerms(){
        this.TermsAccepted = 'TRUE'
      },
      declineTerms(){
        if(confirm('If you decline terms the Clarence device will not be able to function correctly') == true){
          this.TermsAccepted = 'FALSE'
        } else{
          return
        }

      }
    },
     mounted(){
      this.myData = this.DataPass
      this.ProbeArray = this.DataPass[3]

    }

    }
</script>

<style>

</style>